import { alpha } from '@mui/material';

export const PRIORITY_COLOR = {
    high: '#ef4444',
    medium: '#f59e0b',
    low: '#6366f1',
};

export const PRIORITY_BG = {
    high: alpha('#ef4444', 0.08),
    medium: alpha('#f59e0b', 0.08),
    low: alpha('#6366f1', 0.08),
};

export const SIGNAL_DEFINITIONS = [
    { key: 'has_question', label: 'Question (?)' },
    { key: 'has_emoji', label: 'Emoji' },
    { key: 'has_numbers', label: 'Numbers / Stats' },
    { key: 'has_hashtags', label: 'Hashtags (#)' },
    { key: 'has_cta', label: 'Call-to-Action' },
    { key: 'has_links', label: 'Links' },
];

export const FEATURE_CHIPS = [
    'Keyword Gaps',
    'Topic Coverage',
    'Engagement Signals',
    'Tone Analysis',
    'Recommendations',
];

export const COMPARE_MODES = [
    { value: 'competitor',      label: 'vs Competitor',      desc: 'Paste competitor content',          pro: false },
    { value: 'self_best',       label: 'vs Your Best',       desc: 'Compare against your top posts',    pro: true  },
    { value: 'niche_benchmark', label: 'vs Niche Benchmark', desc: 'AI-generated ideal post for your niche', pro: true },
];

export const PLATFORMS = [
    'Instagram', 'LinkedIn', 'Twitter', 'YouTube', 'TikTok', 'Facebook',
];

export const ALIGNMENT_COLORS = {
    excellent: '#10b981',  // 80-100
    good:      '#6366f1',  // 60-79
    fair:      '#f59e0b',  // 40-59
    poor:      '#ef4444',  // 0-39
};

export function alignmentColor(score) {
    if (score == null) return '#94a3b8';
    if (score >= 80) return ALIGNMENT_COLORS.excellent;
    if (score >= 60) return ALIGNMENT_COLORS.good;
    if (score >= 40) return ALIGNMENT_COLORS.fair;
    return ALIGNMENT_COLORS.poor;
}

export function alignmentLabel(score) {
    if (score == null) return '';
    if (score >= 80) return 'Excellent';
    if (score >= 60) return 'Good';
    if (score >= 40) return 'Fair';
    return 'Needs Work';
}

